export const NFT_TORRENT_DESKTOP_APP_URL = 'https://github.com/GravitonINC/nft-torrent-desktop/releases/tag/v1.0.0';